
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { ToastFactory } from "@/utils/ToastFactory";
import { GroupService } from "./group.service";
import { ComputerService } from "@/views/Computers/computer.service";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import dayjs from "dayjs";
import { getRoles } from "@/services/config";
const groupService = new GroupService();

const WEEK_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const computerService = new ComputerService();

const formatDay = (date: any) =>
  date && dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
const formatHour = (hour: any) =>
  hour && dayjs(hour).isValid() ? dayjs(hour).format("HH:mm:00") : "";

export default defineComponent({
  name: "AddGroup",
  components: {},
  data() {
    return {
      role: getRoles(),
      groupId: "" as string,
      errorHour: false as boolean,
      form: {
        group: {
          calendarList: [
            {
              checkIn: "",
              checkOut: "",
              daysWeek: [],
            },
          ] as any,
          status: "" as string,
          amount: 0 as number,
          computers: [] as any[],
        } as any,
      },
      navigator: window.navigator.language,
      selectDate: "" as string,
      selectedDays: [] as any[],
      noDaysSelected: false as boolean,
      maxComputers: 0 as number,
      groupComputers: [] as any[],

      today: dayjs().format("DD/MM/YYYY"),
      getComputers: false as boolean,

      typeStatus: [
        { name: "Ativo", code: "ACTIVE", title_key: "group.fields.active" },
        {
          name: "Inativo",
          code: "INACTIVATED",
          title_key: "group.fields.inactive",
        },
      ],
      weekDays: [
        { name: "domingo", label: "D", enLabel: "Su", value: 0 },
        { name: "segunda", label: "S", enLabel: "M", value: 1 },
        { name: "terça", label: "T", enLabel: "T", value: 2 },
        { name: "quarta", label: "Q", enLabel: "W", value: 3 },
        { name: "quinta", label: "Q", enLabel: "T", value: 4 },
        { name: "sexta", label: "S", enLabel: "F", value: 5 },
        { name: "sabado", label: "S", enLabel: "Sa", value: 6 },
      ],
      params: { page: 0, size: 100 },
      computers: [] as any[],
      disabledButton: false as boolean,
    };
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      form: {
        group: {
          name: { required },
          calendarList: [
            {
              checkIn: {
                required,
              },
              checkOut: {
                required,
              },
            },
          ],
          initDate: { required },
          finishDate: { required },
          status: { required },
          amount: { required },
          computers: { required },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      storeGroup: "groups/getGroup",
      storeComputerAvailable: "computers/getComputersAvailable",
    }),
    dateFieldsDisabled(): boolean {
      return !!this.groupId;
    },

    rangeIsSet(): boolean {
      return (
        dayjs(this.form.group.initDate).isValid() &&
        dayjs(this.form.group.finishDate).isValid()
      );
    },

    occurrenceDates(): any[] {
      const start = dayjs(this.form.group.initDate).startOf("day");
      const finish = dayjs(this.form.group.finishDate).startOf("day");

      if (!this.selectedDays.length || !this.rangeIsSet) return [];

      const days = finish.diff(start, "days");
      if (days < 0) return [];

      const dates = [];

      for (let i = 0; i <= days; i++) {
        const date = start.add(i, "days");
        if (this.selectedDays.includes(date.day())) dates.push(date);
      }

      return dates;
    },

    missingWeekDays(): number[] {
      if (!this.selectedDays.length || !this.rangeIsSet) return [];

      const occurring = this.occurrenceDates.map((date: any) => date.day());

      return this.selectedDays
        .filter((day: number) => !occurring.includes(day))
        .sort((a: number, b: number) => a - b);
    },

    missingWeekDaysLabel(): string {
      return this.missingWeekDays
        .map((day: number) => this.$t(`group.week.${WEEK_KEYS[day]}`))
        .join(", ");
    },

    daysOutOfRange(): boolean {
      return !!this.missingWeekDays.length;
    },

    disabledWeekDays(): number[] {
      if (!this.selectedDays.length) return [];

      return this.weekDays
        .map((day: any) => day.value)
        .filter((day: number) => !this.selectedDays.includes(day));
    },

    occurrencesSummary(): string {
      const dates = this.occurrenceDates;
      if (!dates.length) return "";

      return this.$t("group.occurrencesSummary", {
        count: dates.length,
        first: dates[0].format("DD/MM/YYYY"),
        last: dates[dates.length - 1].format("DD/MM/YYYY"),
      });
    },

    startOutOfWeekDays(): boolean {
      const start = dayjs(this.form.group.initDate).startOf("day");

      return (
        !!this.occurrenceDates.length &&
        start.isValid() &&
        !start.isSame(this.occurrenceDates[0], "day")
      );
    },
  },

  methods: {
    getGroupById() {
      groupService.getGroupById(this.groupId).then(() => {
        const group = this.storeGroup;
        const calendar = group.calendarList?.[0] || {};
        const computers = group.computers || [];

        this.form.group = {
          ...group,
          amount: group.amount || 0,
          initDate: group.createdDate ? dayjs(group.createdDate).toDate() : "",
          finishDate: group.finishDate ? dayjs(group.finishDate).toDate() : "",
          calendarList: [
            {
              ...calendar,
              checkIn: this.toTime(calendar.checkIn),
              checkOut: this.toTime(calendar.checkOut),
            },
          ],
          computers: [...computers],
        };
        this.selectedDays = (calendar.daysWeek || []).map(
          (day: any) => day.day ?? day,
        );
        this.groupComputers = [...computers];
        this.computers = [...computers];
        this.getComputersLenght();
      });
    },

    toTime(hour: string) {
      return hour ? dayjs(`2000-01-01 ${hour}`).toDate() : "";
    },

    availabilityPayload() {
      const { initDate, finishDate, calendarList } = this.form.group;

      return {
        checkin: formatHour(calendarList[0].checkIn),
        checkout: formatHour(calendarList[0].checkOut),
        initDate: formatDay(initDate),
        dateFinish: formatDay(finishDate),
        daysWeek: this.selectedDays,
        selectedDays: this.selectedDays,
      };
    },

    setAvailableComputers() {
      const available = this.storeComputerAvailable.computers || [];
      const availableIds = available.map((computer: any) => computer.id);

      this.computers = [
        ...available,
        ...this.groupComputers.filter(
          (computer: any) => !availableIds.includes(computer.id),
        ),
      ];
      this.getComputers = true;
    },

    getComputersLenght() {
      this.verifyHours();
      this.computers = [...this.groupComputers];
      this.form.group.computers = [...this.groupComputers];

      const data = this.availabilityPayload();
      const isComplete = Object.values(data).every(
        (value: any) => value.length > 0,
      );

      if (this.errorHour || !isComplete) return;

      computerService
        .getComputerAvailableGroup(data)
        .then(() => this.setAvailableComputers());
    },

    idOf(value: any) {
      return value && typeof value === "object" ? value.id : value;
    },

    idsOf(list: any[]) {
      return (list || []).map((item: any) => this.idOf(item));
    },

    groupPayload() {
      const group = this.form.group;
      const calendar = group.calendarList[0];

      return {
        ...group,
        calendarList: [
          {
            ...calendar,
            daysWeek: this.selectedDays,
            checkIn: formatHour(calendar.checkIn),
            checkOut: formatHour(calendar.checkOut),
          },
        ],
        initDate: formatDay(group.initDate),
        finishDate: formatDay(group.finishDate),
        computers: this.idsOf(group.computers),
        organization: this.idOf(group.organization),
        organizationAccess: this.idsOf(group.organizationAccess),
        schedule: this.idsOf(group.schedule),
      };
    },

    addNewGroup() {
      groupService
        .addGroup(this.groupPayload())
        .then((response) => {
          this.$toast.add(ToastFactory.success(this.$t("toast.sucessGroup")));
          this.groupId = response.id;
          if (this.role === "ADMIN_IOSI") {
            this.$router.push({
              name: "addGroupOrganization",
              params: { id: this.groupId },
            });
          } else {
            this.$router.push({
              name: "Groups",
            });
          }
          this.disabledButton = false;
        })
        .catch((e) => {
          this.$toast.add(ToastFactory.error(this.$t("toast.errorGroup")));
          this.disabledButton = false;
        });
    },

    editGroup() {
      groupService
        .updateGroup(this.groupId, this.groupPayload())
        .then(() => {
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessGroupEdit")),
          );
          this.$router.push({ name: "Groups" });
          this.disabledButton = false;
        })
        .catch(() => {
          this.$toast.add(ToastFactory.error(this.$t("toast.errorGroupEdit")));
          this.disabledButton = false;
        });
    },

    deleteGroup() {
      if (this.groupId) {
        groupService
          .deleteGroup(this.groupId)
          .then(() => {
            this.$toast.add(
              ToastFactory.success(this.$t("toast.sucessGroupDelete")),
            );
            this.$router.push({ name: "Groups" });
          })
          .catch((e) => {
            this.$toast.add(
              ToastFactory.error(this.$t("toast.errorGroupDelete")),
            );
          });
      } else {
        this.$router.push({ name: "Groups" });
      }
    },

    confirmDelete(id: any) {
      id == ""
        ? this.$router.push({ name: "Groups" })
        : this.$confirm.require({
            header: this.$t("group.delete"),
            message: this.$t("group.confirmDelete"),
            accept: () => {
              this.deleteGroup();
            },
            reject: () => {
              console.log("reject");
            },
          });
    },

    sendGroup(): void {
      this.v$.form.$touch();
      this.noDaysSelected = !this.selectedDays || this.selectedDays.length == 0;

      if (
        this.v$.form.$invalid ||
        this.errorHour ||
        this.noDaysSelected ||
        this.daysOutOfRange ||
        this.startOutOfWeekDays
      ) {
        this.$toast.add(ToastFactory.error(this.$t("toast.invalidForm")));
        return;
      }

      this.groupId ? this.editGroup() : this.addNewGroup();
    },
    verifyHours(): void {
      if (this.form.group.initDate > this.form.group.finishDate) {
        this.form.group.finishDate = "";
      }
      if (
        this.form.group.calendarList[0].checkIn instanceof Date &&
        this.form.group.calendarList[0].checkOut instanceof Date
      ) {
        const hour1 = this.form.group.calendarList[0].checkIn
          ? this.form.group.calendarList[0].checkIn.getHours()
          : 0;
        const minute1 = this.form.group.calendarList[0].checkIn
          ? this.form.group.calendarList[0].checkIn.getMinutes()
          : 0;

        const hour2 = this.form.group.calendarList[0].checkOut
          ? this.form.group.calendarList[0].checkOut.getHours()
          : 0;
        const minute2 = this.form.group.calendarList[0].checkOut
          ? this.form.group.calendarList[0].checkOut.getMinutes()
          : 0;

        if (hour1 > hour2 || (hour1 === hour2 && minute1 >= minute2)) {
          this.errorHour = true;
        } else {
          this.errorHour = false;
        }
      }
    },
    selectDay(value: number): void {
      if (this.dateFieldsDisabled) return;

      const index = this.selectedDays.indexOf(value);

      if (index === -1) {
        this.selectedDays.push(value);
      } else {
        this.selectedDays.splice(index, 1);
      }
      this.getComputersLenght();
    },
  },

  mounted() {
    this.groupId = this.$route?.params?.id as string;
    this.groupId ? this.getGroupById() : undefined;
  },
});
